<template>
  <div class="frame-modal-background-container blur-active"  @click.self="closeModal">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "ModalFrameBackground",
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style scoped lang="scss">
.frame-modal-background-container {
      background: rgba(var(--color-dark-purple-rgba), .6);
      position: fixed;
      display: flex;
      justify-content: center;
      top:0;left:0;right:0;bottom: 0;
      width: var(--calc-width);
      height: var(--calc-height);
      z-index: 953;
}

@media (max-width: 3024px){
  .blur-active {
    backdrop-filter: blur(6px);
  }
}

@media (max-width: 2100px) {
  .blur-active {
    backdrop-filter: blur(5px);
  }
}

@media (max-width: 1750px) {

  .blur-active {
    backdrop-filter: blur(4px);
  }

}
@media (max-height: 800px) {

  .blur-active {
    backdrop-filter: blur(3px);
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .blur-active {
    backdrop-filter: blur(4px);
  }
}

@media (max-width: 1133px) {

  .blur-active {
    backdrop-filter: blur(3px);
  }
}


@media (min-width: 3025px) {
  .blur-active {
    backdrop-filter: blur(10px);
  }
}
</style>